import { Yield } from '../../abacus/interfaces/yield.interface'

export const intergovernmentalOrganisationYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  }
]
